import React, { useState, useRef, useEffect } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  message,
  Row,
  Col,
  Input,
  Collapse,
  PageHeader,
  Button,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  threeColumnFormItemLayout,
} from "./../../utils/Layouts";
import {
  EditOutlined,
  CloseOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  addNew,
  onSearch,
  onDeleteItem,
  onChange,
  onFinish,
  onUpdateStatus,
  hasAccess,
  itemHasDuplicate,
} from "../../utils/form_utilities";
import moment from "moment";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import SupplierFormModal from "../modals/SupplierFormModal";
import {
  onSupplierSearch,
  onStockSearch,
  addKeysToArray,
  onUnitSearch,
  onProjectSearch,
} from "../../utils/utilities";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import TextAreaGroup from "../../commons/TextAreaGroup";
import numberFormat from "../../utils/numberFormat";
import round from "../../utils/round";
import axios from "axios";
import {
  PO_STATUS_PENDING,
  PO_STATUS_ACCOMPLISHED,
  PO_STATUS_CLOSED,
  APPROVED,
  USER_ADMINISTRATOR,
  TRANS_COMPARATIVE_SLIP,
  OPEN,
  CLOSED,
  ACCESS_APPROVE,
  ACCESS_ADVANCE_SEARCH,
  DISAPPROVED,
  FOR_APPROVAL,
} from "../../utils/constants";
import { sumBy } from "lodash";
import { Link, useLocation, useParams } from "react-router-dom";

import validator from "validator";

import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import FormButtons from "../../commons/FormButtons";

import RecordButtons from "../../commons/RecordButtons";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import { status_options } from "../../utils/Options";
import StockFormModal from "../modals/StockFormModal";
import computeItemDetails from "../../utils/computeItemDetails";

const { Content } = Layout;
const { Panel } = Collapse;

const transaction = "additional-project-estimates";
const url = `/api/${transaction}/`;
const title = "Additional Project Estimates";

const initialItemValues = {
  stock: null,
  quantity: "",
  est_id: null,
  estimate_quantity: "",
};

const initialValues = {
  _id: null,

  requisition_slip_no: null,
  requisition_slip_date: moment(),

  prq_no: null,
  date: moment(),
  date_needed: moment().add({ week: 1 }),

  company: null,
  division: null,
  department: null,

  unit: null,
  purpose: "",
  remarks: "",

  items: [
    {
      ...initialItemValues,
    },
  ],
};

const date_fields = ["date", "date_needed", "requisition_slip_date"];
const transaction_counter = {
  label: "PRQ #",
  key: "prq_no",
};

export default function AdditionalProjectEstimateForm() {
  const location = useLocation();
  const params = useParams();
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [row_selected, setRowSelected] = useState(null);

  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [item, setItem] = useState(initialItemValues);
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
  });
  const [loading, setLoading] = useState(false);
  const [isNext, setIsNext] = useState(false);

  const [state, setState] = useState(initialValues);
  const [search_state, setSearchState] = useState({
    period_covered: [null, null],
    supplier: null,
    po_no: "",
    company: null,
    division: null,
    department: null,
    requisition_slip_no: null,
    approval_status: FOR_APPROVAL,
  });

  const supplierFormModal = useRef(null);
  const unitFormModal = useRef(null);

  const stockFormModal = useRef(null);
  const [search, setSearch] = useState(true);

  const records_column = [
    {
      title: "Status",
      dataIndex: "status",
      width: 40,
      render: (status, record, index) => {
        if (record.deleted && record.deleted.date) {
          return (
            <span className="has-text-danger has-text-weight-bold">VOIDED</span>
          );
        }

        return (
          <span>
            {(record?.status?.approval_status?.match(/\b(\w)/g) || "")
              ?.join("")
              .toUpperCase()}
          </span>
        );
      },
    },
    {
      title: "Doc No",
      dataIndex: "doc_no",
      width: 50,
    },
    {
      title: "Date",
      dataIndex: "date",
      width: 80,
      render: (date) => moment(date).format("MM/DD/YY"),
    },

    {
      title: "Project",
      dataIndex: ["project", "name"],
    },

    {
      title: "Items",
      dataIndex: "items",
      width: 350,
      render: (items) =>
        items
          .slice(0, 4)
          .map((o) => o?.stock?.name)
          .join("/ "),
    },
    {
      title: "Remarks",
      dataIndex: ["remarks"],
      render: (value, record) => {
        return `${value} ${record?.status?.remarks || ""}`;
      },
    },
  ];

  const estimates_column = [
    {
      title: "Category",
      dataIndex: "category",
      width: 200,
    },
    {
      title: "Item",
      dataIndex: ["stock", "name"],
    },

    {
      title: "Est. Qty",
      dataIndex: "estimate_quantity",
      align: "right",
      width: 200,
    },
    {
      title: "Unit",
      dataIndex: ["stock", "unit_of_measure"],
      align: "center",
      width: 80,
    },

    {
      title: "ADDTL REQUEST",
      dataIndex: ["quantity"],
      align: "center",
      width: 100,
      render: (value, record) => {
        const index = record.key;
        return (
          <input
            type="number"
            step={0.01}
            className="has-text-right input-value"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();

                if (isEmpty(record.quantity)) {
                  return message.error("Quantity is required");
                }

                setState((prevState) => {
                  const items = [...(prevState.items || [])];
                  items.push({
                    stock: record.stock,
                    quantity: record.quantity,
                    price: record.price,
                    amount: round(record.quantity * record.price),

                    est_id: record._id,
                  });

                  const estimates = [...(prevState.estimates || [])];

                  estimates[index].quantity = "";

                  return {
                    ...prevState,
                    items,
                    estimates,
                  };
                });

                //remove
              }
            }}
            value={record.quantity}
            onChange={(e) => {
              const value = e.target.value;
              setState((prevState) => {
                let estimates = [...state.estimates];

                estimates[index] = {
                  ...estimates[index],
                  quantity: value,
                };

                return {
                  ...prevState,
                  estimates,
                };
              });
            }}
            align="right"
          />
        );
      },
    },
  ];

  const items_column = [
    {
      title: "",
      key: "action",
      width: 30,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN, FOR_APPROVAL].includes(
              state.status?.approval_status
            ) && (
              <span
                onClick={() => {
                  setState((prevState) => {
                    const items = [...prevState.items];

                    items.splice(index + 1, 0, {
                      ...initialItemValues,
                    });

                    return {
                      ...prevState,
                      items,
                    };
                  });
                }}
              >
                <i className="fas fa-plus"></i>
              </span>
            )}
        </span>
      ),
    },
    {
      title: "Item",
      dataIndex: ["stock"],
      render: (stock, record, record_index) => {
        return (
          record.footer !== 1 && (
            <SelectFieldGroup
              disabled={!isEmpty(record.est_id)}
              value={stock?.name}
              onSearch={(value) =>
                onStockSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const stock = options.stocks?.[index] || null;

                if (stock) {
                  setState((prevState) => {
                    const items = [...(prevState.items || [])];

                    items[record_index].stock = stock;

                    if (items.length - 1 === record_index) {
                      items.push({
                        ...initialItemValues,
                      });
                    }

                    return {
                      ...prevState,
                      items,
                    };
                  });
                }
              }}
              error={errors.stock?.name}
              formItemLayout={null}
              data={options.stocks}
              column="display_name"
              // onAddItem={() => stockFormModal.current.open(record_index)}
            />
          )
        );
      },
    },

    {
      title: "Qty",
      dataIndex: "quantity",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  disabled={!isEmpty(record.est_id)}
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          quantity: value,
                        }),
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                        });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            `${numberFormat(record.quantity)}`
          )}
        </span>
      ),
    },
    {
      title: "UOM",
      dataIndex: ["stock", "unit_of_measure"],
    },

    {
      title: "Unit Cost",
      dataIndex: "Price",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN, FOR_APPROVAL].includes(
            state.status?.approval_status
          ) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  disabled={!isEmpty(record.est_id)}
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.price}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          price: value,
                        }),
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                        });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            numberFormat(record.price)
          )}
        </span>
      ),
    },

    {
      title: "Amount",
      dataIndex: ["amount"],
      align: "right",
      width: 100,
      render: (value) => numberFormat(value),
    },

    {
      title: "",
      key: "action",
      width: 80,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN, FOR_APPROVAL].includes(
              state.status?.approval_status
            ) && (
              <span
                onClick={() =>
                  onDeleteItem({
                    field: "items",
                    index,
                    setState,
                  })
                }
              >
                <i className="fas fa-trash-alt"></i>
              </span>
            )}
        </span>
      ),
    },
  ];

  useEffect(() => {
    setSearchState((prevState) => ({
      ...prevState,
      ...(auth?.user?.company && {
        company: {
          name: auth?.user?.company,
        },
      }),
      ...(auth?.user?.division && {
        division: {
          name: auth?.user?.division,
        },
      }),
      ...(auth?.user?.department && {
        department: auth?.user?.department,
      }),
    }));

    return () => {};
  }, [auth.user.company, auth.user.division, auth.user.department]);

  useEffect(() => {
    if (params?.id) {
      edit({
        record: { _id: params.id },
        setState,
        setErrors,
        setRecords,
        url,
        date_fields,
        setSearch,
      });
    } else {
      onSearch({
        page: 1,
        search_keyword,
        url,
        setRecords,
        setTotalRecords,
        setCurrentPage,
        setErrors,
        advance_search: { ...search_state },
        setSearch,
      });
    }

    return () => {};
  }, []);

  useEffect(() => {
    const getLatestPrice = ({ stock, supplier }) => {
      if (state.supplier && item.stock) {
        axios
          .post("/api/stocks/latest-price", {
            supplier,
            stock,
          })
          .then((response) => {
            setItem((prev_items) => ({
              ...prev_items,
              price: response?.data?.price,
              case_price: response?.data?.case_price,
            }));
          });
      }
    };

    getLatestPrice({ stock: item.stock, supplier: state.supplier });
    return () => {};
  }, [item.stock, state.supplier]);

  useEffect(() => {
    setState((prevState) => {
      let total_amount = sumBy(state.items, (o) => o.amount);
      let total_discount_amount = sumBy(state.items, (o) => o.discount_amount);
      const gross_amount = total_amount;
      total_amount = round(gross_amount - total_discount_amount);

      let vat_amount = state.is_vat_exclusive
        ? round((total_amount * state.vat_rate) / 100)
        : round(
            (total_amount / (1 + state.vat_rate / 100)) * (state.vat_rate / 100)
          );

      const net_of_vat = state.is_vat_exclusive
        ? total_amount
        : round(total_amount / (1 + state.vat_rate / 100));

      total_amount = state.is_vat_exclusive
        ? round(total_amount + vat_amount)
        : total_amount;

      return {
        ...prevState,
        total_amount,
        gross_amount,
        total_discount_amount,
        vat_amount,
        net_of_vat,
      };
    });

    return () => {};
  }, [state.items, state.discounts, state.vat_rate, state.is_vat_exclusive]);

  const record_buttons = (
    <RecordButtons
      has_approve={[OPEN, FOR_APPROVAL].includes(
        records[row_selected]?.status?.approval_status
      )}
      url={url}
      transaction={transaction}
      auth={auth}
      state={records?.[row_selected]}
      approve_label="Approve"
      onSearch={() => {
        setState(initialValues);
        setItem(initialItemValues);
        onSearch({
          page: current_page,
          search_keyword,
          url,
          setRecords,
          setTotalRecords,
          setCurrentPage,
          setErrors,
          advance_search: { ...search_state },
          setSearch,
        });
      }}
      additional_buttons={[
        records?.[row_selected]?.status?.approval_status === OPEN &&
          hasAccess({ auth, access: ACCESS_APPROVE, location }) && (
            <span
              className="button is-danger is-outlined is-small control"
              onClick={() => {
                onUpdateStatus({
                  url,
                  state: records?.[row_selected],
                  approval_status: DISAPPROVED,
                  user: auth.user,
                  onSearch: () => {
                    onSearch({
                      page: current_page,
                      search_keyword,
                      url,
                      setRecords,
                      setTotalRecords,
                      setCurrentPage,
                      setErrors,
                      advance_search: search_state,
                      setSearch,
                    });
                  },
                });
              }}
            >
              <span>Disapprove</span>
            </span>
          ),
      ]}
      onNew={() => {
        setState({
          ...initialValues,
          date: moment(),
          items: [{ ...initialItemValues }],
        });

        setRecords([]);

        setSearch(false);
      }}
    />
  );

  return (
    <Content className="content-padding">
      <SupplierFormModal
        setField={(supplier) => {
          setState((prevState) => ({
            ...prevState,
            supplier,
          }));
        }}
        ref={supplierFormModal}
      />
      <StockFormModal
        setField={(stock) => {
          setItem((prevState) => ({
            ...prevState,
            stock,
          }));
        }}
        ref={stockFormModal}
      />
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          {/* <Searchbar
            name="search_keyword"
            onSearch={(value, e) => {
              e.preventDefault();
              onSearch({
                page: 1,
                search_keyword,
                url,
                setRecords,
                setTotalRecords,
                setCurrentPage,
                setErrors,
              });
              setRowSelected(null);
            }}
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={() => {
              setState(initialValues);
              setItem(initialItemValues);
              setRecords([]);
            }}
          /> */}
        </div>
      </div>

      {/* Start of Advance Search */}
      {hasAccess({
        auth,
        access: ACCESS_ADVANCE_SEARCH,
        location,
      }) && (
        <Row>
          <Col span={24} className="m-b-1">
            <Collapse>
              <Panel header="Advance Search" key="1">
                <PageHeader
                  backIcon={false}
                  style={{
                    border: "1px solid rgb(235, 237, 240)",
                  }}
                  onBack={() => null}
                  title="Advance Filter"
                  subTitle="Enter appropriate data to filter records"
                >
                  <div className="or-slip-form">
                    <Row>
                      <Col span={8}>
                        <RangeDatePickerFieldGroup
                          label="Date"
                          name="period_covered"
                          value={search_state.period_covered}
                          onChange={(dates) =>
                            setSearchState((prevState) => ({
                              ...prevState,
                              period_covered: dates,
                            }))
                          }
                          formItemLayout={smallFormItemLayout}
                        />
                      </Col>

                      <Col span={8}>
                        <SelectFieldGroup
                          label="Item"
                          value={search_state.stock?.name}
                          onSearch={(value) =>
                            onStockSearch({ value, options, setOptions })
                          }
                          onChange={(index) => {
                            const stock = options.stocks[index];
                            setSearchState((prevState) => ({
                              ...prevState,
                              stock,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.stocks}
                          column="display_name"
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={8}>
                        <SimpleSelectFieldGroup
                          label="Status"
                          name="approval_status"
                          value={search_state.approval_status}
                          onChange={(value) => {
                            onChange({
                              key: "approval_status",
                              value: value,
                              setState: setSearchState,
                            });
                          }}
                          error={errors.approval_status}
                          formItemLayout={smallFormItemLayout}
                          options={[FOR_APPROVAL, ...status_options] || []}
                        />
                      </Col>
                      <Col span={8}>
                        <TextFieldGroup
                          label="PRN"
                          name="prq_no"
                          error={errors.prq_no}
                          formItemLayout={smallFormItemLayout}
                          value={search_state.prq_no}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value.toUpperCase(),
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={8}>
                        <Row>
                          <Col offset={8} span={12}>
                            <Button
                              type="info"
                              size="large"
                              icon={<SearchOutlined />}
                              onClick={() => {
                                onSearch({
                                  page: 1,
                                  search_keyword,
                                  url,
                                  setRecords,
                                  setTotalRecords,
                                  setCurrentPage,
                                  setErrors,
                                  advance_search: search_state,
                                  setSearch,
                                });
                              }}
                            >
                              Search
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={8}></Col>
                      <Col span={8}></Col>
                    </Row>
                  </div>
                </PageHeader>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      )}

      {/* End of Advanced Search */}

      <div style={{ background: "#fff", padding: 24 }}>
        <div className="is-flex">
          <div className="module-title flex-1">{title}</div>
          <div>
            <span className="has-text-weight-bold">O</span> - Open ;{" "}
            <span className="has-text-weight-bold">A</span> - Approved ;{" "}
            <span className="has-text-weight-bold">D</span> - Disapproved ;{" "}
            <span className="has-text-weight-bold">C</span> - Cancelled ;
          </div>
        </div>
        <Divider />
        {!search ? (
          <Form
            onFinish={(values) => {
              onFinish({
                loading,
                onSubmit,
                state: {
                  ...state,
                  pathname: location.pathname,
                  items: state.items.filter((o) => !isEmpty(o.stock?._id)),
                },
                auth,
                url,
                setErrors,
                setState,
                date_fields,
                setLoading,
                cb: () => {
                  console.log(isNext);
                  if (isNext) {
                    setState({ ...initialValues, date: moment() });
                    setItem(initialItemValues);
                    setRecords([]);
                    onCompaniesSearch({ value: "", options, setOptions });
                    setSearch(false);
                    setIsNext(false);
                  } else {
                    onSearch({
                      page: 1,
                      search_keyword,
                      url,
                      setRecords,
                      setTotalRecords,
                      setCurrentPage,
                      setErrors,
                      advance_search: { ...search_state },
                      setSearch,
                    });
                  }
                },
              });
            }}
            initialValues={initialValues}
          >
            {state[transaction_counter.key] && (
              <TextFieldGroup
                disabled={true}
                label={transaction_counter.label}
                value={state[transaction_counter.key]}
                error={errors.remarks}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            <Row>
              <Col span={12}>
                <DatePickerFieldGroup
                  label="Date"
                  name="date"
                  value={state.date}
                  onChange={(value) => {
                    onChange({
                      key: "date",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors.date}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
              <Col span={12}>
                <DatePickerFieldGroup
                  label="Date Needed"
                  name="date_needed"
                  value={state.date_needed}
                  onChange={(value) => {
                    onChange({
                      key: "date_needed",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors.date}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <SelectFieldGroup
                  label="Project"
                  value={state.project?.name}
                  onFocus={() => {
                    onProjectSearch({ value: "", setOptions });
                  }}
                  onSearch={(value) => onProjectSearch({ value, setOptions })}
                  onChange={(index) => {
                    const project = options.projects?.[index] || null;
                    setState((prevState) => ({
                      ...prevState,
                      project,
                    }));
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={options.projects}
                  column="name"
                  error={errors.project}
                  // onAddItem={() => accountFormModal.current.open()}
                />
              </Col>
              <Col span={12}>
                <TextFieldGroup
                  disabled
                  label="Account"
                  name="account"
                  value={state.project?.account?.name}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
            </Row>

            <TextAreaGroup
              label="Remarks"
              name="remarks"
              value={state.remarks}
              error={errors.remarks}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />

            <Row>
              <Col offset={4} span={12}>
                <Button
                  onClick={() => {
                    //display items in project estimates
                    axios
                      .post("/api/project-estimates/estimates", {
                        project_id: state.project?._id,
                      })
                      .then((response) => {
                        if (response.data) {
                          setState((prevState) => ({
                            ...prevState,
                            estimates: [...(response.data || [])].map((o) => {
                              return {
                                ...o,
                                estimate_quantity: o.quantity,
                                quantity: "",
                                est_id: o._id,
                              };
                            }),
                          }));
                        }
                      })
                      .catch((err) => {
                        return message.error(
                          "There was an error processing your request"
                        );
                      });
                  }}
                >
                  Search
                </Button>
              </Col>
            </Row>

            <Row style={{ margin: "20px 0 20px 0" }}>
              <Col span={12}>
                <span className="module-title">MATERIAL COST ESTIMATE</span>
              </Col>
            </Row>

            <Table
              dataSource={addKeysToArray([...(state.estimates || [])])}
              columns={estimates_column}
              pagination={{
                pageSize: 20,
              }}
              rowClassName={(record, index) => {
                if (record.footer === 1) {
                  return "footer-summary has-text-weight-bold";
                }
              }}
            />

            {state.po_status && (
              <TextFieldGroup
                label="PO Status"
                name="status"
                value={state.po_status}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            {state.status?.approval_status && (
              <Row>
                <Col span={12}>
                  <TextFieldGroup
                    key="status"
                    disabled={true}
                    label="Status"
                    name="status"
                    value={`${state.status.approval_status} / ${
                      state.status.user.name
                    } / ${moment(state.status.datetime).format(
                      "MM/DD/YY hh:mm A"
                    )}`}
                    formItemLayout={smallFormItemLayout}
                    readOnly
                  />
                </Col>
                <Col span={12}>
                  <TextFieldGroup
                    key="created-by"
                    disabled={true}
                    label="Created By"
                    value={`${state.created_by.name} / ${moment(
                      state.created_at
                    ).format("MM/DD/YY hh:mm A")}`}
                    formItemLayout={smallFormItemLayout}
                    readOnly
                  />
                </Col>
              </Row>
            )}

            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("MM/DD/YY hh:mm A")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            <Row style={{ margin: "20px 0 20px 0" }}>
              <Col span={12}>
                <span className="module-title">Addtl Requests</span>
              </Col>
            </Row>

            <Table
              dataSource={addKeysToArray(state.items)}
              columns={items_column}
              pagination={false}
            />

            <FormButtons
              state={state}
              auth={auth}
              loading={loading}
              url={url}
              transaction="purchase-requests"
              onDelete={onDelete}
              initialValues={initialValues}
              initialItemValues={initialItemValues}
              setState={setState}
              setItem={setItem}
              setIsNext={setIsNext}
              has_next={true}
              save_statuses={[FOR_APPROVAL]}
              onSearch={() => {
                if (params?.id) {
                  history.goBack();
                } else {
                  onSearch({
                    page: current_page,
                    search_keyword,
                    url,
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                    advance_search: { ...search_state },
                    setSearch,
                  });
                }
              }}
              onEdit={() => {
                edit({
                  record: { _id: state._id },
                  setState,
                  setErrors,
                  setRecords,
                  url,
                  date_fields,
                  setSearch,
                });
              }}
              onPrint={() => {
                window.open(`/print/${transaction}/${state._id}`, "_tab");
              }}
            />
          </Form>
        ) : (
          <div>
            {record_buttons}
            <Table
              dataSource={addKeysToArray(records)}
              columns={records_column}
              rowKey={(record) => record._id}
              onRow={(record, index) => {
                return {
                  onClick: (e) => {
                    setRowSelected(index);
                  },
                  onDoubleClick: (e) => {
                    setSearch(false);
                    edit({
                      record,
                      setState,
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                      setSearch,
                    });
                  },
                };
              }}
              rowClassName={(record, index) => {
                if (row_selected === index) return "row-is-selected";
              }}
              pagination={{
                current: current_page,
                defaultCurrent: current_page,
                onChange: (page) =>
                  onSearch({
                    page,
                    search_keyword,
                    url,
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                    advance_search: { ...search_state },
                    setSearch,
                  }),
                total: total_records,
                pageSize: 10,
              }}
            />
            {record_buttons}
          </div>
        )}
      </div>
    </Content>
  );
}
